module.exports = __webpack_public_path__ + "static/media/angular-icon.f1e4843b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/angular-icon.webp
// module id = 249
// module chunks = 1